<template>
	<div>
		<div v-show="!d_previewPdf" id="proposal" class="contentarea">
			<!--div class="contentregion"-->
				<!--div class="contentdisplay"-->
					<div class="contentoutline">
						<div class="content">
							<!--div  id="proposal-form" class="document"-->
								<div class="contentview">
									<form class="rec-form">
												<div class="form1-group row g-0" style="gap: 1rem">
													<div class="text-start col-sm-6" style="padding-right: 0px">
														<img :src="c_tenantLogoURL" alt="Logo"  class="ms-auto logo me-2" />
													</div>
													<div class="row col-sm-6" g-0="" style="padding: 0px ">
														<input type="text"  class="form-control-plaintext ta-end" v-model="d_proposalBody.tenantName" placeholder="Company Name">
														<input type="text" class="form-control-plaintext ta-end" v-model="d_proposalBody.tenantStreetAddress" placeholder="Company Address">
														<div class="g-0 d-flex">
															<input type="text" class="form-control-plaintext ta-end" v-model="d_proposalBody.tenantCity" placeholder="City">
															<span>,</span>
															<input type="text" class="form-control-plaintext ta-end" v-model="d_proposalBody.tenantStateProvince" placeholder="State/Province">
															<input type="text" class="form-control-plaintext ta-end" v-model="d_proposalBody.tenantZipCode" placeholder="Zip code/Postal code">
														</div>
														<input type="text" class="form-control-plaintext ta-end" v-model="d_proposalBody.tenantWebsite" placeholder="Company website">
														<input type="telephone" class="form-control-plaintext ta-end" v-model="d_proposalBody.tenantPhone" placeholder="Company phone number"/>
													</div>
												</div>
												<br>
												<br>
												<h3 class="fw-bold text-center">Proposal</h3>
												<div class="form1-group align-baseline g-0">
													<div class="row align-baseline g-0">
														<label for="proposaldate" class="col-sm-1 col-form-label text-start">Date:</label>
														<div class="col-sm-3">
															<input type="date" class="form-control-plaintext text-start" id="proposaldate" v-model="d_proposalBody.proposalDate">
														</div>
													</div>
													<div class="row align-baseline g-0">
														<label for="proposalnumber" class="col-sm-3 col-form-label text-start textleft">Proposal No:</label>
														<div class="col-sm-2">
															<input type="text" class="form-control-plaintext text-start" id="proposalnumber" v-model="d_proposalBody.proposalNo" placeholder="Proposal Number">
														</div>
													</div>
												</div>
												<br>
												<div class="form1-group row col-sm-6 g-0">
													<div>
														<input type="text" class="form-control-plaintext text-start" v-model="d_proposalBody.accountName" placeholder="Client Name">
														<input type="text" class="form-control-plaintext text-start" v-model="d_proposalBody.accountStreetAddress" placeholder="Client Address">
															<div class="AddressDiv">
																<input type="text" class="form-control-plaintext text-start" v-model="d_proposalBody.accountCity" placeholder="City">
																<span>,</span>
																<input type="text" class="form-control-plaintext text-start" v-model="d_proposalBody.accountStateProvince" placeholder="State/Province">
																<input type="text" class="form-control-plaintext text-start" v-model="d_proposalBody.accountZipCode" placeholder="Zip code/Postal code">
															</div>
													
														<input type="telephone" class="form-control-plaintext text-start" v-model="d_proposalBody.accountPhone" placeholder="Client phone number"/>
														<input type="text" class="form-control-plaintext text-start" v-model="d_proposalBody.accountEmail" placeholder="Client email"/>
													</div>
												</div>
												<br>
												<div class="form1-group row g-0 fw-bold">
													<label for="projectname" class="col-sm-3 col-form-label" style="text-align:start;">Project Name:</label>
													<div class="col-sm-9">
														<input type="text" class="form-control-plaintext text-start fw-bold" id="projectname" v-model="d_proposalBody.projectName" placeholder="Project Name">
													</div>
												</div>
												<br>
												<br>
												<div class="form1-group" style="text-align:start;">
													<!--label for="scopeofwork" class="form-label fw-bold"> Scope of Work</label-->
													<input type="text" class="form-control-plaintext text-start form-label fw-bold" v-model="d_proposalBody.scopeOfWorkLabel" placeholder="Scope of Work">
													<hr />
													<!--textarea class="form-control"  style="border:none;" rows="4" id="scopeofwork" v-model="c_scopeOfWork" placeholder="Include your scope of work here." @dblClick="m_EditScope"></textarea-->
													<vue-editor id="scopeEditor" v-model="d_proposalBody.scopeOfWork" @text-change="m_editorChange"></vue-editor>
												</div>
												<br>
												<br>
												<div class="form1-group" style="text-align:start;">
													<!--label for="exclusions" class="form-label fw-bold text-start" style="text-align:start;">Exclusions</label-->
													<input type="text" class="form-control-plaintext text-start form-label fw-bold" v-model="d_proposalBody.exclusionsLabel" placeholder="Exclusions">
													<hr />
													<!--textarea class="form-control" style="border:none;" rows="3" id="exclusions" v-model="d_proposalBody.exclusions" placeholder="Exclusions are included here." wrap="hard"></textarea-->
													<vue-editor id="exclusionEditor" v-model="d_proposalBody.exclusions"></vue-editor>
												</div>
												<br>
												<br>
												<div class="containerDiv">
													<!--label for="proposalvalue" class="col-sm-9 col-form-label text-end"><h5>TOTAL AMOUNT OF THIS PROPOSAL:</h5></label-->
													<input type="text" class="form-control-plaintext text-start form-label fw-bold" v-model="d_proposalBody.proposalAmountLabel" placeholder="TOTAL AMOUNT OF THIS PROPOSAL:">
													<!--div class="col-sm-3"-->
														<input type="text" class="form-control-plaintext fw-bold" id="proposalvalue" v-model="d_proposalBody.projectValue" placeholder="Proposal Amount">
													<!--/div-->
												</div>
												<br>
												<br>
												<div class="form1-group g-0" style="text-align:start;">
													<!--label for="alternates" class="form-label fw-bold">Alternates</label-->
													<input type="text" class="form-control-plaintext text-start form-label fw-bold" v-model="d_proposalBody.alternatesLabel" placeholder="Alternates">
													<hr />
													<textarea class="form-control" style="border:none;" rows="2" id="alternates" v-model="d_proposalBody.alternates" placeholder="Include any ADD or DEDUCT alternates here."></textarea>
												</div>
												<br>
												<br>
												<div class="form1-group row g-0">
													<textarea class="form-control" style="border:none;" rows="2" id="alternates" v-model="d_proposalBody.thankYou"></textarea>
												</div>
												<br>
												<br>
												<div class="form1-group row g-0">
													<input type="text" class="form-control-plaintext text-start" v-model="d_proposalBody.ending" placeholder="Sincerely">
													<span class="fw-bold">Sign:<canvas title='Click and write signature with mouse. Double click to erase' id="signatureCanvas" width="250" height="80" style="border:1px solid #000000;">Signature</canvas></span>
													<input type="text" class="form-control-plaintext text-start" v-model="d_proposalBody.teamMemberName" placeholder="Your Name">
													<input type="text" class="form-control-plaintext text-start" v-model="d_proposalBody.teamMemberRole" placeholder="Your Role">
													<input type="tel" class="form-control-plaintext text-start" v-model="d_proposalBody.teamMemberPhone" placeholder="Your Cell Phone">
													<input type="text" class="form-control-plaintext text-start" v-model="d_proposalBody.teamMemberEmail" placeholder="Your Email">
												</div>												
									</form>
								</div>
							<!--/div-->
						</div>
					</div>
				<!--/div-->
			<!--/div-->
		</div>
		<!-- DIV used for Pdf printing -->
		<!--div v-show="d_previewPdf"-->
		<div v-show="false">
			<div id="proposalPdf" class="contentarea noborder">
			<!--div class="contentregion"-->
				<!--div class="contentdisplay"-->
					<div class="contentoutline">
						<div class="content">
							<!--div  id="proposal-form" class="document"-->
								<div class="contentview">
									<form class="rec-form">
												<div class="form1-group row g-0" style="gap: 4rem">
													<div class="text-start col-sm-6" style="padding-right: 0px">
														<img :src="c_tenantLogoURL" alt="Logo"  class="ms-auto logo me-2" />
													</div>
													<div style="padding-right:0px; text-align:end;">
														<div class="ta-end">{{c_tenantName}} </div>
														<div class="ta-end">{{c_tenantStreetAddress}} </div>
														<div class="ta-end">{{c_tenantCity}},{{c_tenantStateProvince}}  {{c_tenantZipCode}} </div>
														<div class="ta-end">{{c_tenantWebsite}} </div>
														<div class="ta-end">{{c_tenantPhone}} </div>
													</div>
												</div>
												<br>
												<br>
												<h3 class="fw-bold text-center">Proposal</h3>
												<div>
													<div class="align-baseline g-0">
														<div class="ta-start">Date: {{c_proposalDate}} </div>
														<div class="ta-start">Proposal No:{{c_proposalNo}} </div>
													</div>
												</div>
												<br>
												<div class="form1-group row col-sm-6 g-0">
													<div>
														<div class="ta-start">{{c_accountName}}</div>
														<div class="ta-start">{{c_accountStreetAddress}}</div>
														<div class="ta-start">{{c_accountCity}},{{c_accountStateProvince}}  {{c_accountZipCode}}</div>
														<div class="ta-start">{{c_accountPhone}}</div>
														<div class="ta-start">{{c_accountEmail}}</div>
													</div>
												</div>
												<br>
												<div class="form1-group row g-0 fw-bold">
												<span>
													<span class="col-sm-3 col-form-label text-start">Project Name:</span>
													<span class="col-sm-9 text-start">{{c_projectName}}</span>
												</span>
												</div>
												<br>
												<br>
												<!--Use v-html-->
												<div class="form1-group" style="text-align:start;">
													<!--label for="scopeofwork"  class="fw-bold text-start" >Scope of Work</label-->
													<input type="text" class="form-control-plaintext text-start form-label fw-bold" v-model="c_scopeOfWorkLabel" placeholder="Scope of Work">
													<hr />
													<div v-html="c_scopeOfWork" style="text-align:left;"></div>
												</div>
												<br>
												<br>
												<!--Use v-html-->
												<div v-if="c_exclusions" class="text-start" style="text-align:start;">
													<!--label for="exclusions" class="form-label fw-bold text-start" style="text-align:start;">Exclusions</label-->
													<input type="text" class="form-control-plaintext text-start form-label fw-bold" v-model="c_exclusionsLabel" placeholder="Exclusions">
													<hr />
													<div v-html="c_exclusions" style="text-align:left;"></div>
												</div>
												<br>
												<br>
												<div class="containerDiv" style="text-align:start;">
													<!--label for="proposalvalue" class="col-sm-9 col-form-label text-end"><h5>TOTAL AMOUNT OF THIS PROPOSAL:</h5></label-->
													<input type="text" class="form-control-plaintext text-start form-label fw-bold" v-model="c_proposalAmountLabel" placeholder="TOTAL AMOUNT OF THIS PROPOSAL:">
													<!--div class="col-sm-3"-->
														<input type="text" class="form-control-plaintext fw-bold" id="proposalvalue" v-model="c_projectValue" placeholder="Proposal Amount">
													<!--/div-->
												</div>
												<br>
												<br>
												<div v-if="c_alternates" class="form1-group g-0 text-start" style="text-align:start;">
													<!--label for="alternates" class="form-label fw-bold " >Alternates</label-->
													<input type="text" class="form-control-plaintext text-start form-label fw-bold" v-model="c_alternatesLabel" placeholder="Alternates">
													<hr />
													<div v-html="c_alternates" style="text-align:left;"></div>
												</div>
												<br>
												<br>
												<div class="form1-group row g-0">
												<h7>{{c_thankYou}}</h7>
												</div>
												<br>
												<br>
												<div>
													<h7>{{c_ending}}</h7>
													<div v-show="c_signatureImage" class="text-start"><img id="signatureImage" class="text-start" src=null width="250" height="50"></img></div>
													<input type="text" class="form-control-plaintext text-start" v-model="c_teamMemberName" placeholder="Your Name">
													<input type="text" class="form-control-plaintext text-start" v-model="c_teamMemberRole" placeholder="Your Role">
													<input type="tel" class="form-control-plaintext text-start" v-model="c_teamMemberPhone" placeholder="Your Cell Phone">
													<input type="text" class="form-control-plaintext text-start" v-model="c_teamMemberEmail" placeholder="Your Email">
												</div>												
									</form>
								</div>
							<!--/div-->
						</div>
					</div>
				<!--/div-->
			<!--/div-->
		</div>
		</div>
		<!--iframe id="previewPDF" v-show="d_previewPdf" :src="c_previewPdfObject" height="842px" width="595px"></iframe-->
		<iframe id="previewPDF" v-show="d_previewPdf" :src="c_previewPdfObject" height="842px" width="1200px"></iframe>
	</div>
</template>
<script>
import {userSettings} from "@/utils/ref-data.js";
import {proposals,fn_AsyncGET} from "@/utils/api.js";
import {api_baseURL} from "@/utils/init.js";
import {kbdpAlert,fn_fmtSf,fn_fmtMoney,fn_hrefVwRec} from "@/utils/util.js";
import {VueEditor, Quill} from "vue2-editor";
import html2pdf from 'html2pdf.js'
export default {
	name: "kt-proposal",
	components: {
	VueEditor
	},
data() {
		return {
		d_today:(new Date()).toJSON().slice(0,10),
		d_accountRec:null,
		d_proposalId:null,
		d_proposalBody:{
					p_ending:null,
					tenantLogoURL:null,
					tenantName:null,
					tenantStreetAddress:null,
					tenantCity:null,
					tenantStateProvince:null,
					tenantZipCode:null,
					tenantWebsite:null,
					tenantPhone:null,
					proposalDate:(new Date()).toJSON().slice(0,10),
					proposalNo:this.p_recInfo.No,
					accountName:null,
					accountStreetAddress:null,
					accountCity:null,
					accountStateProvince:null,
					accountZipCode:null,
					accountPhone:null,
					accountEmail:null,
					projectName:this.p_recData.opportunityName,
					scopeOfWork:this.p_recData.opportunityDetails,
					exclusions:null,
					projectValue:fn_fmtMoney(this.p_recData.value),
					alternates:null,
					teamMemberName:null,
					teamMemberRole:null,
					teamMemberPhone:null,
					teamMemberEmail:null,
					thankYou:"Thank you for allowing our company the opportunity to bid this project. If you have any questions, please feel free to contact me.",
					ending:"Sincerely,",
					alternatesLabel:"Alternates",
					exclusionsLabel:"Exclusions",
					scopeOfWorkLabel:"Scope of Work",
					proposalAmountLabel:"TOTAL AMOUNT OF THIS PROPOSAL:",
	
					},
		d_errMessage:null,
		d_previewPdf: false,
		d_pdfFileName:'proposal-'+this.p_recInfo.No+'.pdf',
		d_ending:"Sincerely,",
		d_options:{
					margin: 0.3,
					filename: 'proposal-'+this.p_recInfo.No+'.pdf',
					image: { 
					type: 'jpeg', 
					quality: 2.0 
					},
					html2canvas: { 
							scale: 2,
							useCORS:true
								},
					jsPDF: { 
							unit: 'in', 
							format: 'a4', 
							orientation: 'portrait' 
							}
					},
		d_previewPdfObject:null,
		d_signatureImage:false,

		};
	},
props: {
		p_recInfo: Object,
		p_recData: Object
	},
created() {


		
},
mounted() {

			
			this.d_recData=this.p_recData;
			this.d_recInfo=this.p_recInfo;
			
			console.log("p_recData");
			console.log(this.p_recData);
			
			
			console.log("p_recInfo");
			console.log(this.p_recInfo);
			
			let params={opportunityId:this.p_recData.opportunityId};
			proposals.fn_getProposal(params)
			.then((resp) =>
			{
			if (!resp.error && resp.recordData) 
				{
				console.log('Get proposal');
				console.log(resp);
				this.d_proposalId=resp.recordData.proposalId;
				var db_proposalBody=JSON.parse(resp.recordData.proposalBody);
				this.d_proposalBody={...this.d_proposalBody, ...db_proposalBody};
				}	
			else {
			fn_AsyncGET('account/'+this.p_recData.clientAccount.accountNo,null)
			.then((resp) => {
							if (resp.error) {
							let msg = `Unable to read account:${this.p_recData.clientAccount.accountNo} Error: ` + (resp.error || "");
							kbdpAlert.showErr(msg);
							} else {
							console.log(resp);
							this.d_accountRec=resp.recordData;
							this.d_proposalBody.accountName=resp.recordData.accountName;
							this.d_proposalBody.accountStreetAddress=resp.recordData.streetAddress;
							this.d_proposalBody.accountCity=resp.recordData.city;
							this.d_proposalBody.accountStateProvince=resp.recordData.stateProvince;
							this.d_proposalBody.accountZipCode=resp.recordData.zipCode;
							}
					});
			fn_AsyncGET('appTenantSettings').then((resp) => {
			
				if (resp.error) {
					let msg = `Unable to read appTenantSetting Error: ` + (resp.error || "");
					kbdpAlert.showErr(msg);
					} else {
				console.log("appTenantSetting");
				console.log(resp);
				this.d_loading = null;
				this.d_tenantSettings = resp.general || {};
				this.d_proposalBody.tenantName=resp.general.tenantName;
				this.d_proposalBody.tenantStreetAddress=resp.general.streetAddress;
				this.d_proposalBody.tenantCity=resp.general.city;
				this.d_proposalBody.tenantStateProvince=resp.general.stateProvince;
				this.d_proposalBody.tenantZipCode=resp.general.zipCode;
				this.d_proposalBody.tenantPhone=resp.general.phone;
				this.d_proposalBody.tenantWebsite=resp.general.website;
				this.d_proposalBody.tenantLogoURL=api_baseURL + resp.general.tenantLogoURL;
				}
			});
			
			fn_AsyncGET('teamMemberContactInfo/'+this.p_recInfo.Team[0].teamMemberId).then((resp) => {
				if (resp.error) {
					let msg = `Unable to read TeamMemberContactInfo Error: ` + (resp.error || "");
					kbdpAlert.showErr(msg);
					} else {
				console.log("teamMemberContactInfo");
				console.log(resp);
				this.d_loading = null;
				this.d_teamMember = resp.recordData || {};
				this.d_proposalBody.teamMemberName=resp.recordData.teamMemberName;
				this.d_proposalBody.teamMemberRole=resp.recordData.role;
				this.d_proposalBody.teamMemberPhone=resp.recordData.phoneNo;
				this.d_proposalBody.teamMemberEmail=resp.recordData.email;
				}
			});
		}
		
	});


$(document).ready(function(){
  $(document).mousemove(function(event){
    console.log('Mouse at'+event.pageX + ", " + event.pageY);
  });
});
	
//signature Canvas
		var canvas = document.getElementById('signatureCanvas');
		var ctx = canvas.getContext('2d');
		console.log('Canvas offset left:'+$(canvas).offset().left);
		console.log('Canvas offset top:'+$(canvas).offset().top);
		console.log(JSON.stringify(canvas));
		

		
//Variables
		var canvasx = $(canvas).offset().left;
		var canvasy = $(canvas).offset().top;
		var globalCounter=0;

		
		var last_mousex = 0;
		var last_mousey = 0;
		var mousex = 0;
		var mousey = 0;
		var mousedown = false;
		var tooltype = 'draw';
		var mycanvas = document.getElementById("signatureCanvas");
		var _this=this;

		
//Use draw|erase
	var use_tool = function(tool) {
			tooltype = tool; //update
		}
		
	

		
//Canvas Click
	$(canvas).on('click', function(e) {
		console.log('canvas click');
		use_tool('draw');
	});

	
//Canvas DblClick
	$(canvas).on('dblclick', function(e) {
		ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
		document.getElementById("signatureImage").src=null;
		_this.d_signatureImage=false;
	});	
	

//Mousedown
	$(canvas).on('mousedown', function(e) {
		//last_mousex=mousex=e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft-mycanvas.offsetLeft-440;
		//last_mousey=mousey=e.clientY + document.body.scrollTop + document.documentElement.scrollTop-mycanvas.offsetLeft-2040; 
		const rect = canvas.getBoundingClientRect();
		mousex=e.clientX - rect.left;
		mousey = e.clientY - rect.top;
		mousedown = true;
		
	});

//Mouseup
	$(canvas).on('mouseup', function(e) {
		mousedown = false;
		document.getElementById("signatureImage").src=canvas.toDataURL();
		_this.d_signatureImage=true;
		console.log('DataURL');
		console.log(canvas.toDataURL());
	});

//Mousemove
	$(canvas).on('mousemove', function(e) {

		//mousex=e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft-mycanvas.offsetLeft-440;
		//mousey=e.clientY + document.body.scrollTop + document.documentElement.scrollTop-mycanvas.offsetLeft-2040;

		const rect = canvas.getBoundingClientRect();
		mousex=e.clientX - rect.left;
		mousey=e.clientY - rect.top;
		console.log('canvas X:'+ mycanvas.getBoundingClientRect().left);
		console.log('canvas Y:'+ mycanvas.getBoundingClientRect().top);
		

		if(mousedown) {
			ctx.beginPath();
			if(tooltype=='draw') {
				ctx.globalCompositeOperation = 'source-over';
				ctx.strokeStyle = 'black';
				ctx.lineWidth = 3;
			} else {
				ctx.globalCompositeOperation = 'destination-out';
				ctx.lineWidth = 10;
			}
        ctx.moveTo(last_mousex,last_mousey);
        ctx.lineTo(mousex,mousey);
        ctx.lineJoin = ctx.lineCap = 'round';
        ctx.stroke();
    }
	//Output
    console.log('current: '+mousex+', '+mousey+'<br/>last: '+last_mousex+', '+last_mousey+'<br/>mousedown: '+mousedown);
    
	last_mousex = mousex;
    last_mousey = mousey; 
	

});

},
computed:{
		c_tenantLogoURL() {	return this.d_proposalBody.tenantLogoURL;},
		c_tenantName(){return this.d_proposalBody.tenantName},
		c_tenantStreetAddress(){return this.d_proposalBody.tenantStreetAddress;},
		c_tenantCity(){return this.d_proposalBody.tenantCity;},
		c_tenantStateProvince(){return this.d_proposalBody.tenantStateProvince;},
		c_tenantZipCode(){return this.d_proposalBody.tenantZipCode;},
		c_tenantPhone(){return this.d_proposalBody.tenantPhone;},
		c_tenantWebsite(){return this.d_proposalBody.tenantWebsite;},
		c_projectValue() {return this.d_proposalBody.projectValue;},
		c_proposalNo() { return this.d_proposalBody.proposalNo;},
		c_accountName() { return this.d_proposalBody.accountName;},
		c_accountStreetAddress() { return this.d_proposalBody.accountStreetAddress;},
		c_accountCity() { return this.d_proposalBody.accountCity;},
		c_accountZipCode() { return this.d_proposalBody.accountZipCode;},
		c_accountStateProvince() {return this.d_proposalBody.accountStateProvince;},
		c_scopeOfWork(){  return this.d_proposalBody.scopeOfWork;},
		c_exclusions(){return this.d_proposalBody.exclusions;},
		c_alternates(){return this.d_proposalBody.alternates;},
		c_acountPhone(){ return this.d_proposalBody.accountPhone;},
		c_accountEmail(){ return this.d_proposalBody.accountEmail;},
		c_projectName(){return this.d_proposalBody.projectName;},
		c_teamMemberName(){ return this.d_proposalBody.teamMemberName;},
		c_teamMemberRole(){ return this.d_proposalBody.teamMemberRole;},
		c_teamMemberPhone(){ return this.d_proposalBody.teamMemberPhone;},
		c_teamMemberEmail(){ return this.d_proposalBody.teamMemberEmail;},
		c_proposalDate(){ return this.d_proposalBody.proposalDate;},
		c_btnSaveDisabled(){return !(this.d_proposalChanged);},
		c_previewPdfObject(){ return this.d_previewPdfObject;},
		c_ending(){return this.d_proposalBody.ending;},
		c_thankYou() {return this.d_proposalBody.thankYou;},
		c_alternatesLabel() {return this.d_proposalBody.alternatesLabel;},
		c_scopeOfWorkLabel() {return this.d_proposalBody.scopeOfWorkLabel;},
		c_exclusionsLabel() {return this.d_proposalBody.exclusionsLabel;},
		//c_signatureImage() {return document.getElementById("signatureImage")?.getAttribute('src');},
		c_signatureImage(){return this.d_signatureImage}

},
methods: {
			
			m_editScope(){
							this.d_editScope=true;
							kbdpAlert.showOk('Edit Scope on');
						},
			m_previewToggle() {
						this.preview = !this.preview;
			},
			m_handlePrint(divPrint) {
				var printContents = document.getElementById(divPrint).innerHTML;
				var originalContents = document.body.innerHTML;

				document.body.innerHTML = printContents;

				window.print();

				document.body.innerHTML = originalContents;
				window.location.reload();
			},
			m_previewPdf(){
			this.d_previewPdf=!this.d_previewPdf;
			if(this.d_previewPdf) {
			var proposalEl = document.getElementById('proposalPdf');
			html2pdf().from(proposalEl).set(this.d_options).toPdf()
			.output('datauristring')
			.then(function(pdfObject){
					var previewEl = document.getElementById('previewPDF');
					previewEl.src=pdfObject;
					});
			}
				},
			m_generatePdf(){
			var element = document.getElementById('proposalPdf');
			html2pdf().from(element).set(this.d_options).save();
			
				},
			m_saveProposal(){
				console.log('In save');
				console.log(JSON.stringify(this.d_proposalBody));
				let params={proposalId:this.d_proposalId,opportunityId:this.p_recData.opportunityId,
							proposalName:null,proposalBody:JSON.stringify(this.d_proposalBody)};
				fn_saveProposal(this,params);
				},
			m_saveProposalTemplate(templateName){
			console.log('In m_saveProposalTemplate:'+templateName);
			if(templateName){
				let params={proposalId:null,opportunityId:null,proposalName:templateName,template:'Y',
							proposalBody:JSON.stringify(this.d_proposalBody)};
				fn_saveProposal(this,params);	
					}
			},
			m_applyProposalTemplate(templateName){
			console.log('In m_applyProposalTemplate:'+templateName);
			if(templateName){
				let params={opportunityId:null,
							proposalId:null,
							proposalName:templateName,
							template:'Y'
							};
				proposals.fn_getProposal(params).then((resp) =>
				{
				if (!resp.error && resp.recordData) 
					{
					console.log('Get proposal template');
					console.log(resp);
					this.d_proposalBody=JSON.parse(resp.recordData.proposalBody);
					}	
				});
			}
		}
	},
watches:{
		p_recData(){this.d_recData=this.p_recData;},
		p_recInfo(){this.d_recInfo=this.p_recInfo;},
		d_opportunityDetails(){	console.log('opportunityDetails Changed');
								console.log(this.d_opportunityDetails);
								this.d_proposalBody.opportunityDetails=this.d_opportunityDetails;
								},
}
};
function fn_saveProposal(vc,params)
	{
				console.log('In fn_saveproposal');		
				
					proposals.fn_saveProposal(params)
					.then((resp) => {
						if (resp.error) {
							let msg = `Unable to save proposal Error: ` + (resp.error || "");
							kbdpAlert.showErr(msg);
						} else {
								kbdpAlert.showOk('Proposal' + " was saved successfully.");
								if(!vc.d_proposalId&&!params.template) vc.d_proposalId=resp.upsRecHdr.proposalId;
							}
							
					});
	}

</script>
<style scoped>
	@media (min-width: 992px) {
		.custom-mt-lg {
			margin-top: 0;
		}
	}
	@media (min-width: 768px) {
		.custom-mt-md {
			margin-top: 0;
		}
	}
	.h-9{
		font-size: 12px;
		text-align: end;
	}
	.form-control-plaintext{
		padding: 0;
	}
	.form-control {
		border-radius: 6;
		border: 1;
	}
	.form-control-custom {
		border-radius: 0;
		border: 0;
		border-bottom: 1px solid black;
		width: 100%;
	}
	.custom-textarea {
		display: block;
		overflow: hidden;
		resize: none;
	}
	.textarea {
		width: 100% !important;
		height: 100%;
	}
	.logo {
		height:50px;
		width:50px;
		float: left;
	}
	.btn__print {
		border: 0;
		border-radius: 6px;
		padding: 5px 15px;
		margin-left: 10px;
		margin-top: 12px;
		font-weight: bold;
		background: #4076ba;
		color: #FFFFFF;
	}
	.btn__print:hover {
		background: #4065aa;
	}
	.btn__preview {
		border: 0;
		border-radius: 6px;
		padding: 5px 15px;
		margin-left: 10px;
		margin-top: 12px;
		font-weight: bold;
		background: #FFFFFF;
		color: #4076ba;
		transition-duration: .3s;
	}
	.btn__preview:hover {
		background: #f4f4f4;
	}
	.vertbreak {
		display: inline-flex;
		height: 100%;
		align-items: center;
		padding: 12px;
	}
	.vertline {
		width: 1px;
		height: 100%;
		background-color: grey;
		border-radius: 0px;
	}
	hr {
		opacity: 1;
		background: #4076ba;
		padding: 1px;
		margin-top: 0;
	}
	.proposalview {
		display: grid;
		position: absolute;
		width: 100%;
		height: 100%;
		grid-template-rows: min-content 1fr;
		grid-template-columns: min-content 1fr;
	} 
	.headerarea{
		display: block;
		height: 60px;
		padding: 0;
		margin: 0;
		grid-area: 1/1/2/-1;
		background: #f3f2ef;
	}
	.headerbar {
		display: flex;
		position: relative;
		width: 100%;
		height: 60px;
		box-sizing: border-box;
		border-bottom: none;
		background-color: #FFFFFF;
		box-shadow: rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px;
		z-index: 2;
		justify-content: space-between;
		overflow: hidden;
	}
	.ribbonarea {
		width: 100%;
		padding-left: 10px;
		overflow: hidden;
	}
	.ribbon{
		display: inline-flex;
		width: 100%;
		overflow: hidden;
	}
	.ribboncontent{
		display: flex;
		white-space: nowrap;
	}
	.buttongrouping {
		display: inline-block;
		height: 60px;
		vertical-align: top;
	}
	.contentarea {
		display: block;
		position: relative;
		grid-area: 2/1/3/-1;
		background: #f3f2ef;
	}
	.contentregion {
		width: 100%;
		height: 100%;
	}
	.contentdisplay{
		position: relative;
		width: 100%;
		padding-top: 20px;
		padding-bottom: 45px;
	}
	.contentoutline {
		width: 816px;
		margin-left: auto;
		margin-right: auto;
	}
	.content {
		position: relative;
		width: 816px;
		min-height: 1056px;
		background-color: #FFFFFF;
	}
	.document {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		align-items: center;
	}
	.contentview {
		width: 100%;
		height: 100%;
		padding: 96px;
	}
.noborder{
		border:none;
		}
.AddressDiv{
  border:none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left:0px;
  margin-right:0px;
  width:90%;
}
.containerDiv{
  border:none;
  display: flex;
  flex-direction: row;
  }
.corporateAddressDiv{
	position: absolute;
	top: 8px;
	right: 16px;
	font-size: 18px;
}
.moneycolor{color:blue;}
.textleft{	text-align: left;}
.fw-bold{font-weight: bold;}
.ta-end{text-align: end;}
.ta-start{text-align: start;}
</style>